"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;

var _reactJss = require("react-jss");

var _fonts = require("../../styles/fonts");

var _variables = require("../../styles/variables");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// import { globalStyles } from "../../styles/global";
var useStyles = (0, _reactJss.createUseStyles)(_objectSpread(_objectSpread({}, _fonts.fontStyles), {}, {
  table: function table(props) {
    return {
      width: "100%",
      maxWidth: "100%",
      marginBottom: "1rem",
      backgroundColor: "transparent",
      fontFamily: "IranSansX",
      color: _variables.colors.wolf,
      direction: "rtl",
      borderCollapse: "collapse",
      fontSize: props.size === "xs" ? "0.625rem" : "0.875rem"
    };
  },
  thead: function thead(props) {
    return {
      padding: props.size === "xs" ? "15px 10px 0px 10px" : "27px 23px 0px 23px"
    };
  },
  header: function header(props) {
    return {
      backgroundColor: _variables.colors.swan,
      borderColor: _variables.colors.swan,
      height: props.size === "xs" ? "38px" : "48px",
      textAlign: "right",
      paddingLeft: props.size === "xs" ? "10px" : "23px",
      paddingRight: props.size === "xs" ? "10px" : "23px",
      fontWeight: 300
    };
  },
  row: function row(props) {
    return {
      verticalAlign: "top",
      padding: props.size === "xs" ? "15px 10px 0px 10px" : "27px 23px 0px 23px",
      "&:last-child": {
        padding: props.size === "xs" ? "15px 10px 15px 10px" : "27px 23px 27px 23px"
      }
    };
  }
}), {
  name: 'pds-list'
});
exports.useStyles = useStyles;